// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"701":"f04e70588e1ee9dd","2188":"3c87e36df84f453e","3677":"382045d88369552f","4404":"e2da2dd5eb0291ec","7824":"cd77fca22d867efb","8528":"4818f4da9223fbc9"}[chunkId] + ".css";
};